"use client";

import { c as _c } from "react/compiler-runtime";
import Carousel from "@/components/explore-sections/shared/carousel";
import ImageComponent from "@/components/ui/image";
import TopGifts1 from "@/assets/images/top_gifts1.webp";
import { useMediaQuery } from "react-responsive";
import { useRouter } from "next/navigation";
import { useEffect, useState, useMemo } from "react";
import { useQueries } from "@tanstack/react-query";
import { getCollectionById } from "@/services/api/collections";
import { HOME_TOP_GIFTS_COLLECTION_IDS } from "@/constants/product";
import { Button } from "@/components/ui/button";
import SectionHeading from "@/components/explore-sections/shared/heading";
import { HomeSectionSkeleton } from "@/components/ui/skeleton";
interface TopGiftCollection {
  id?: string | number;
  slug?: string;
  name?: string;
  media_url?: string;
  [key: string]: unknown;
}
export default function TopGiftsCollections() {
  const $ = _c(22);
  const [isMounted, setIsMounted] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      maxWidth: 1024
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isMobile = useMediaQuery(t0);
  const router = useRouter();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      queries: HOME_TOP_GIFTS_COLLECTION_IDS.map(_temp)
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const collectionQueries = useQueries(t1);
  const isLoading = collectionQueries.some(_temp2);
  let t2;
  if ($[2] !== collectionQueries) {
    t2 = collectionQueries.map(_temp3).filter(_temp4);
    $[2] = collectionQueries;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const topGiftsData = t2;
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setIsMounted(true);
    };
    t4 = [];
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  if (!isMounted || isLoading) {
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <HomeSectionSkeleton />;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    return t5;
  }
  if (topGiftsData.length === 0) {
    return null;
  }
  let t5;
  if ($[7] !== isMobile || $[8] !== topGiftsData) {
    t5 = isMobile ? topGiftsData.slice(0, 2) : topGiftsData;
    $[7] = isMobile;
    $[8] = topGiftsData;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const displayData = t5;
  let t6;
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SectionHeading heading="Thoughtful Collections" subHeading="Discover exclusives and handcrafted pieces that celebrate craft and culture" />;
    t7 = <p className="font-outfit font-normal md:hidden text-center text-sm text-v2-on-surface-variant/80 uppercase tracking-widest mt-2">Beautiful things. Thoughtfully curated.</p>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  let t8;
  if ($[12] !== isMobile) {
    t8 = !isMobile && {
      itemsPerPage: 4
    };
    $[12] = isMobile;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== displayData || $[15] !== isMobile || $[16] !== router) {
    t9 = (item_0, idx) => <div key={item_0.id || idx} className={`group flex flex-col justify-start items-center lg:items-start ${isMobile ? displayData.length <= 2 ? "flex-1 me-2 last:me-0 h-[280px] sm:h-[340px] md:h-[390px]" : "flex-none w-[44%] h-[280px] me-2 sm:h-[340px] md:h-[390px]" : "flex-none w-[calc((100%-72px)/4)] h-[330px]"} cursor-pointer`} onClick={() => {
      if (isMobile) {
        router.push(item_0.url);
      }
    }}><div className="group/wrapper rounded-[1.68px] sm:rounded-lg w-full h-[220px] sm:h-[280px] md:h-[330px] transition-transform duration-300 ease-in-out relative overflow-hidden"><ImageComponent src={item_0.image} alt={item_0.description} width={400} height={400} sizes="(max-width: 640px) 300px, (max-width: 1024px) 200px, 360px" className="w-full h-full object-cover object-center transition-transform duration-300 ease-in-out hover:scale-105 lg:group-hover/wrapper:scale-105" fallbackSrc={TopGifts1} /><div className="pointer-events-none z-10 opacity-0 bg-black/30 justify-center items-center transition-opacity duration-300 ease-in-out absolute inset-0 lg:group-hover/wrapper:opacity-100 lg:group-hover/wrapper:pointer-events-auto hidden lg:flex"><Button onClick={e => {
            e.stopPropagation();
            router.push(item_0.url);
          }} className={"lg:text-lg font-lora font-bold bg-[#037A6A]\n                 text-sm text-[#F3F3F3] lg:px-4 lg:py-4 px-3 py-2\n                 rounded-lg transition-opacity duration-300 border-none hover:bg-[#037A6A]/90 h-auto"}>VIEW ALL</Button></div><Button onClick={e_0 => {
          e_0.stopPropagation();
          router.push(item_0.url);
        }} className="lg:hidden absolute bottom-2 left-1/2 -translate-x-1/2 text-xs font-bold py-1.5 lg:py-3 lg:px-6 px-3 mt-4 lg:text-xl bg-[#037A6A] rounded-lg font-lora text-[#EFFEFC] hover:bg-[#025a4f] transition-all duration-300 transform hover:scale-105 whitespace-nowrap border-none h-auto">Order Now</Button></div><h3 className="line-clamp-1 whitespace-normal text-center font-lora text-[#303030] mt-2 pb-3 text-base font-medium leading-6 group-hover:text-[#735C00] lg:text-left lg:text-xl lg:leading-7 overflow-hidden">{item_0.description}</h3></div>;
    $[14] = displayData;
    $[15] = isMobile;
    $[16] = router;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== displayData || $[19] !== t8 || $[20] !== t9) {
    t10 = <div className="mt-8 px-2 lg:mt-12 lg:px-12 max-w-[1440px] mx-auto">{t6}{t7}<div className="snap-x snap-mandatory w-full mt-8 overflow-x-auto lg:mt-8"><Carousel items={displayData} {...t8} renderItem={t9} /></div></div>;
    $[18] = displayData;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}
function _temp4(item) {
  return item !== null;
}
function _temp3(query_0) {
  const collection = query_0.data as TopGiftCollection;
  if (!collection || !collection.slug || !collection.id) {
    return null;
  }
  return {
    id: collection.id,
    description: collection.name || "",
    image: collection.media_url || TopGifts1,
    url: `/listing/${collection.slug}?id=${collection.id}`
  };
}
function _temp2(query) {
  return query.isLoading;
}
function _temp(id) {
  return {
    queryKey: ["collection", id.toString()],
    queryFn: () => getCollectionById(id.toString()),
    staleTime: Infinity
  };
}